export default __webpack_public_path__ + "static/media/a037-l.042737f2.jpg";